<template>
    <div>
        <b-row>
            <b-col cols="6">
                <fg-input label="Start Date" required>
                    <el-date-picker v-model="startDate"
                                    type="date"></el-date-picker>
                </fg-input>
            </b-col>
            <b-col cols="6">
                <fg-input label="End Date" required>
                    <el-date-picker v-model="endDate"
                                    type="date"></el-date-picker>
                </fg-input>
            </b-col>
        </b-row>
        <b-table striped
            :items="items"
            :busy="isLoading"
            :fields="fields"
        >
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>
            <template #cell(created)="data">
                <span>{{data.item.created | formatDate('LLL')}}</span>
            </template>
            <template #cell(statusName)="data">
                <b-badge :variant="data.item.statusStyleVariant">
                    {{data.item.statusName}}
                </b-badge>
            </template>
            <template #cell(details)="data">
                <b-icon icon="pencil-square" variant="info" v-b-tooltip.hover title="Details" @click="openDetails(data.item)" style="cursor:pointer"></b-icon>
            </template>
        </b-table>
        
    <!-- Details -->
    <b-modal id="detailsModal" ref="detailsModal"
                hide-footer
                size="xl" title="Refill Request Batch Details">
        <RefillRequestBatchDetails v-model="selectedItem"></RefillRequestBatchDetails>
    </b-modal>
    </div>
</template>

<script lang='ts'>
import RefillRequestBatchDetails from '@/components/RefillRequestBatch/RefillRequestBatchDetails.vue';
import { RefillRequestBatch, RefillRequestBatchStatus } from '@/models/RefillRequestBatch';
import {Component, Mixins, Watch, Vue} from 'vue-property-decorator';
import moment from 'moment';
import { DatePicker } from 'element-ui'
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: 'RefillRequestBatchHistory',
    components: {
        [DatePicker.name]: DatePicker,
        RefillRequestBatchDetails
    }
})
export default class RefillRequestBatchHistory extends Vue{
    private items : Array<RefillRequestBatch> = new Array<RefillRequestBatch>();
    private selectedItem : RefillRequestBatch = new RefillRequestBatch();
    private startDate : Date | null = null;
    private endDate : Date | null= null;
    private fields = [
        { key: "created", label: "Created"},
        { key: "statusName", label: "Status"},
        { key: "rxCount", label: "RXs Included"},
        { key: "details", label: ""},
    ]

    created() {
        this.endDate = moment().toDate();
        this.startDate = moment().subtract(1, 'month').toDate();
        this.loadData();
    }
    
    private isLoading = false;
    @Watch('startDate')
    @Watch('endDate') 
    loadData(){
        if(this.startDate === null || this.endDate === null || moment(this.startDate).isAfter(this.endDate)) return;

        this.isLoading = true;
        this.$http.get<Array<RefillRequestBatch>>('RefillRequestBatch/history',{params: {
            startDate: this.startDate, endDate: this.endDate,
        }})
        .then(res => {
            this.items = res.data?.map(i => new RefillRequestBatch(i)) || new Array<RefillRequestBatch>();
        })
        .catch(err => {
            console.error('Error loading RefillRequestBatch history', {err, response: err.response});
            this.$notification(NotificationOptions.error(err));
        })
        .finally(() => {
            this.isLoading = false;
        })
    }

    openDetails(item:RefillRequestBatch){
        this.selectedItem = item;
        this.$bvModal.show('detailsModal');
    }

}
</script>

<style>

</style>